import { useDispatch, useSelector } from "src/store";

import { selectBatchActionEntity, selectLicenseDetails, showDetails } from "@dashboard/devices/store";
import ElasticService from "@services/elasticService";
import { HoverRow } from "@shared/table/HoverRow";
import { TableRowCells } from "@shared/table/TableRowCells";
import { Row } from "@tanstack/react-table";

import { DeviceTableData } from "./DeviceTable.utils";

const excludedColumns = ["groupName", "moveLicenseCheckbox"];
const linkColumns = ["name", "groupName"];

export const DeviceTableRow = (props: Row<DeviceTableData>) => {
    const dispatch = useDispatch();
    const details = useSelector(selectLicenseDetails);
    const entity = useSelector(selectBatchActionEntity);

    const isSelected = details?.selectedId === props.original.id;

    const handleTableItemClick = (e: React.MouseEvent<HTMLTableRowElement>) => {
        const target = e.target as HTMLElement;
        const cell = target.closest("[data-column-id]");
        const columnId = cell?.getAttribute("data-column-id") || "";

        ElasticService.createTransaction("tableElementClick", {
            table: "devices",
            click_element: linkColumns.includes(columnId) ? "link" : "text",
        });

        if (excludedColumns.includes(columnId)) {
            return;
        }

        if (entity !== "license") {
            dispatch(
                showDetails({
                    type: "license",
                    selectedId: props.original.id,
                }),
            );
        }
    };

    return (
        <HoverRow {...props} selected={isSelected} onClick={handleTableItemClick}>
            <TableRowCells row={props} />
        </HoverRow>
    );
};
